import { useCallback } from 'react';

import { useUserCountry } from '@hooks/shared/useUserCountry';
import { capitalizeWords } from '@lib/utils/stringHelper';

import { JOBS_TABS_MAP } from './jobsTabs';

type UseCountryWording = {
  getCountryWording: (
    word: GeoSpecificWord,
    formatting?: 'capitalize' | 'lowercase' | 'uppercase',
    version?: WordVersion
  ) => string;
};

export const useCountryWording = (): UseCountryWording => {
  const { userCountry } = useUserCountry();

  const getCountryWording = useCallback(
    (
      word: GeoSpecificWord,
      formatting: 'capitalize' | 'lowercase' | 'uppercase' = 'lowercase',
      version: WordVersion = 'full'
    ): string => {
      const mappedWord = WORDING_MAP[word][userCountry][version];
      switch (formatting) {
        case 'capitalize':
          return capitalizeWords(mappedWord);
        case 'uppercase':
          return mappedWord.toUpperCase();
        case 'lowercase':
        default:
          return mappedWord;
      }
    },
    [userCountry]
  );

  return { getCountryWording };
};

const WORDING_MAP = { ...JOBS_TABS_MAP };
